import React from 'react';
import {Col, Popover, PopoverBody, Row} from "reactstrap";
import ProgressiveImage from "react-progressive-image";
import "./index.css"
import assets from "../../../../../../util/assets";
import {PricingType} from "../../pricing/type";
import {getAgeGroupDiv} from "../../../../../../util/utility";
import {PricingSmall} from "../../pricing/small";
import Button from "reactstrap/lib/Button";
import DropdownItem from "../../dropdown-item/DropdownItem";
import PropTypes from "prop-types";

function GalleryItem(props) {
    return (
        <div className="no-margin" key={`my-library-row-gallery-${props.index}`}>
            <Row className="publish-list-item-display-flex-align-items-center">
                <Col md="10" className="no-padding">
                    <div className="display-flex">

                        <ProgressiveImage
                            delay={1000}
                            src={props.gallery.thumbnail_url}
                            placeholder="placeholder"
                        >
                            {(src, loading) => {
                                return loading ? (
                                        <img alt="my-library-thumbnail" className="my-library-thumbnail-dynamic"
                                             src={assets.clipstore.placeholder}/>
                                    ) :
                                    (
                                        <div className="my-library-thumbnail-dynamic-bg"
                                             style={{backgroundImage: "linear-gradient(to bottom, rgba(26, 26, 26, 0.32), rgba(41, 41, 41, 0.53)),url('" + props.gallery.thumbnail_url + "')"}}
                                             onClick={() => {
                                                 props.thumbnailClicked(props.gallery.id)
                                             }}>

                                            <div className="my-library-thumbnail-duration-publish-container">
                                                <div className="my-library-thumbnail-gallery-container">
                                                    <img src={assets.clipstore.gallery_videos} alt="gallery videos" width={16}/>
                                                    <span className="my-library-thumbnail-gallery-text">{props.gallery.videos.length}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )

                            }}
                        </ProgressiveImage>

                        <div className="my-library-video-list">
                            {/*<div className="my-library-video-title">*/}
                            {/*    <span>{props.gallery.title}</span>*/}
                            {/*</div>*/}
                            <div className="my-library-video-description">{props.gallery.description}</div>
                            <div className="my-library-video-date display-flex-justify-video-flex-start-align-items-center">
                                <div className="badge badge-sm text-white">
                                    {getAgeGroupDiv(props.gallery.age_group, "age-group-24")}
                                </div>
                                <PricingSmall pricing={props.gallery.pricing}/>
                            </div>
                        </div>
                    </div>
                </Col>

                <Col md="1"
                     style={{textAlign: 'right'}}
                     onClick={() => {
                         props.editGallery(props.gallery.id)
                     }}
                     className="no-padding primary-color underline cursor-pointer">
                    Edit
                </Col>


                {
                    props.delete_gallery.isFetching ?
                        <Col md="1"
                             style={{textAlign: 'right'}}
                             className="no-padding primary-color underline cursor-pointer">
                            <img src={assets.loading_blue} width={24} alt="loading"/>
                        </Col>
                        :
                        <Col md="1"
                             style={{textAlign: 'right'}}
                             onClick={() => {
                                 props.deleteGallery(props.gallery.id)
                             }}
                             className="no-padding primary-color underline cursor-pointer">
                            Delete
                        </Col>
                }


            </Row>
        </div>
    );
}

GalleryItem.propTypes = {
    index: PropTypes.string.isRequired,
    gallery: PropTypes.object.isRequired,
    thumbnailClicked: PropTypes.func.isRequired,
    editGallery: PropTypes.func.isRequired,
    deleteGallery: PropTypes.func.isRequired,
};

export default GalleryItem;